module.exports = ".click-to-edit-wrapper .hidden {\n  visibility: hidden; }\n\n.click-to-edit-wrapper .disabled {\n  color: rgba(127, 127, 127, 0.7); }\n\n.click-to-edit-wrapper .read-only-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 3px;\n  white-space: nowrap; }\n\n.click-to-edit-wrapper .hidden-text {\n  font-style: italic; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/click-to-edit/click-to-edit.component.scss
// module id = ./src/app/controls/click-to-edit/click-to-edit.component.scss
// module chunks = main